import React from 'react';
import { GalleryPhoto, getConfiguration } from '../models';
import { EmptyPhoto, Photo } from './';

interface GalleryCardProps {
    openInNewTab: boolean;
    title: string;
    titleUrl: string;
    photos: GalleryPhoto[];
    loading: boolean;
}

export const GalleryCard = ({ title, titleUrl, photos, loading, openInNewTab }: GalleryCardProps) => {
    return <div className="app-card">
        <h3><a href={titleUrl}>{title} <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12.8 24" height="12"><path d="M0,24.1C0,16.1,0,8.1,0,0c4.2,4,8.4,8,12.6,12.1C8.4,16.1,4.2,20.1,0,24.1z"></path></svg></a></h3>
        <div className="app-photo-list">
            {photos.map((photo, index) => loading === true
                ? <EmptyPhoto key={index} />
                : <Photo key={index}
                    openInNewTab={openInNewTab}
                    photo={photo.photo}
                    tooltip={`${photo.name} (${photo.age} m., ${photo.city})`}
                    link={`${getConfiguration().serviceEndpoint}/foto/nuotrauka.cfm?id=${photo.photoId}`} />)}
        </div>
    </div>;
}